import { del, get, post, put } from '../utils/axios'

export const getFactionsAPI = async (body) => {
  return await get('factions', body)
}

export const createFactionsAPI = async (body) => {
  return await post('factions', body)
}

export const updateFactionsAPI = async (param, body) => {
  return await put('factions', param, body)
}

export const deleteFactionsAPI = async (param) => {
  return await del('factions', param)
}

export const getFactionsExpandAPI = async (body) => {
  return await get('search/faction/th-eng', body)
}